<template lang="html">
  <div>
    <b-form @submit="login">
      <b-form-group
        id="exampleInputGroup1"
        label="Email address:"
        label-for="exampleInput1"
        description="We'll never share your email with anyone else."
      >
        <b-form-input
          id="exampleInput1"
          v-model="email"
          type="email"
          required
          placeholder="Enter email"
        />
      </b-form-group>

      <b-form-group
        id="exampleInputGroup2"
        label="Password:"
        label-for="password_input"
      >
        <b-form-input
          id="password_input1"
          v-model="password"
          type="password"
          required
          placeholder="Enter password"
        />
      </b-form-group>
      <b-button type="submit" variant="primary">Login</b-button>
    </b-form>
    <p v-show="$store.state.login_error" class="mt-5 alert alert-danger">
      Error: {{ $store.state.login_error_message }} Please try again. If
      problems persist,
      <b-link :to="{ name: 'password_reset' }">
        go to the password reset page.
      </b-link>
    </p>
    <p v-show="!$route.meta.login_required" class="mt-5">
      Don't have an account?
      <b-link :to="{ name: 'trial' }">Go to sign-up page.</b-link>
    </p>
    <p class="mt-5">
      Problems logging in?
      <b-link :to="{ name: 'password_reset' }">
        Go to password reset page.
      </b-link>
    </p>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      password2: ""
    };
  },
  methods: {
    login(evt) {
      evt.preventDefault();
      console.log("login");
      this.$store.dispatch("login", {
        email: this.email,
        password: this.password
      });
    }
  }
};
</script>

<style lang="css" scoped></style>
